import { render, staticRenderFns } from "./ModalBuscarPaciente.vue?vue&type=template&id=19394f5f&scoped=true"
import script from "./ModalBuscarPaciente.vue?vue&type=script&lang=ts"
export * from "./ModalBuscarPaciente.vue?vue&type=script&lang=ts"
import style0 from "./ModalBuscarPaciente.vue?vue&type=style&index=0&id=19394f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19394f5f",
  null
  
)

export default component.exports